import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba4e6d8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dialog favorites-dialog"
}
const _hoisted_2 = { class: "dialog-header favorites-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "シミュレーション操作メニュー", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "dialog-content favorites-content" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eraser" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("リセットする")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row single-col" }, [
  /*#__PURE__*/_createElementVNode("div", null, " "),
  /*#__PURE__*/_createElementVNode("button", {
    class: "button",
    onclick: "location.href='https://raraya.co.jp/simguide'"
  }, "ガイドページへ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "favorites-divider" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全ての選択を解除していいですか？", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideDialog && _ctx.hideDialog(...args)))
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                id: "resetButton",
                class: "button resetButton",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onResetClick && _ctx.onResetClick(...args)))
              }, _hoisted_10),
              _createElementVNode("button", {
                id: "showGuide",
                class: "button showGuide",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onShowGuideClick && _ctx.onShowGuideClick(...args)))
              }, "操作説明表示")
            ]),
            _hoisted_11,
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favorites, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row favorite-row",
                key: index
              }, [
                _createElementVNode("button", {
                  class: "button favorite-button",
                  onClick: ($event: any) => (_ctx.onSaveClick(index))
                }, _toDisplayString(item) + "番に保存する", 9, _hoisted_13),
                _createElementVNode("button", {
                  class: "button favorite-button",
                  onClick: ($event: any) => (_ctx.onLoadClick(index)),
                  disabled: _ctx.disableds[index]
                }, _toDisplayString(item) + " 番を呼び出す", 9, _hoisted_14)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog, {
      onOnYes: _ctx.onResetYes,
      showEventName: "showResetConfirm"
    }, {
      default: _withCtx(() => [
        _hoisted_15
      ]),
      _: 1
    }, 8, ["onOnYes"])
  ], 64))
}